import { toast } from 'react-toastify'

import { useCustomTranslation } from '../../../infrastructure/translation/useCustomTranslation'

export const useApiDocumentationHook = () => {
  const { t } = useCustomTranslation('common')

  const copyAccessToken = async () => {
    const token = localStorage.getItem('token')
    if (!token) {
      throw new Error('Invalid token')
    }
    navigator.clipboard.writeText(`Bearer ${token}`)
    toast.success(t('copied_to_clipboard'))
  }

  return {
    copyAccessToken,
    t,
  }
}
